
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '国内口岸名称',
value: this.$route.params.DP_NAME
}, {
label: '国内口岸说明',
value: this.$route.params.DP_JNAME
}, {
label: '国内口岸说明',
value: this.$route.params.DP_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_DomesticPortsDetail.vue